import { Box } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { skipToMainContentStyles } from '../utils/accessibility';

/**
 * Skip to main content link for keyboard navigation
 * Allows keyboard users to skip navigation and go directly to main content
 * Requirements: 15.7 (Accessibility - keyboard navigation)
 */
const SkipToContent = () => {
  const { t } = useTranslation();

  const handleSkip = (e: React.MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault();
    const mainContent = document.getElementById('main-content');
    if (mainContent) {
      mainContent.focus();
      mainContent.scrollIntoView();
    }
  };

  return (
    <Box
      component="a"
      href="#main-content"
      onClick={handleSkip}
      sx={skipToMainContentStyles}
      tabIndex={0}
    >
      {t('accessibility.skip_to_content') || 'Skip to main content'}
    </Box>
  );
};

export default SkipToContent;
